"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AccountCircleOutlined_1 = __importDefault(require("@material-ui/icons/AccountCircleOutlined"));
var AccountBalanceWallet_1 = __importDefault(require("@material-ui/icons/AccountBalanceWallet"));
var AttachFile_1 = __importDefault(require("@material-ui/icons/AttachFile"));
var ArrowBack_1 = __importDefault(require("@material-ui/icons/ArrowBack"));
var ArrowRight_1 = __importDefault(require("@material-ui/icons/ArrowRight"));
var ArrowLeft_1 = __importDefault(require("@material-ui/icons/ArrowLeft"));
var ArrowDropUp_1 = __importDefault(require("@material-ui/icons/ArrowDropUp"));
var ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
var ArrowDropUpOutlined_1 = __importDefault(require("@material-ui/icons/ArrowDropUpOutlined"));
var ArrowDropDownOutlined_1 = __importDefault(require("@material-ui/icons/ArrowDropDownOutlined"));
var AccountCircle_1 = __importDefault(require("@material-ui/icons/AccountCircle"));
var AlternateEmailOutlined_1 = __importDefault(require("@material-ui/icons/AlternateEmailOutlined"));
var Assignment_1 = __importDefault(require("@material-ui/icons/Assignment"));
var AssignmentOutlined_1 = __importDefault(require("@material-ui/icons/AssignmentOutlined"));
var BathtubOutlined_1 = __importDefault(require("@material-ui/icons/BathtubOutlined"));
var BuildOutlined_1 = __importDefault(require("@material-ui/icons/BuildOutlined"));
var CreditCard_1 = __importDefault(require("@material-ui/icons/CreditCard"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var ExitToApp_1 = __importDefault(require("@material-ui/icons/ExitToApp"));
var ExploreOutlined_1 = __importDefault(require("@material-ui/icons/ExploreOutlined"));
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var ExpandLess_1 = __importDefault(require("@material-ui/icons/ExpandLess"));
var LocalPlay_1 = __importDefault(require("@material-ui/icons/LocalPlay"));
var Directions_1 = __importDefault(require("@material-ui/icons/Directions"));
var DirectionsBoatOutlined_1 = __importDefault(require("@material-ui/icons/DirectionsBoatOutlined"));
var DirectionsRailwayOutlined_1 = __importDefault(require("@material-ui/icons/DirectionsRailwayOutlined"));
var DirectionsOutlined_1 = __importDefault(require("@material-ui/icons/DirectionsOutlined"));
var GetApp_1 = __importDefault(require("@material-ui/icons/GetApp"));
var Language_1 = __importDefault(require("@material-ui/icons/Language"));
var LocalCafeOutlined_1 = __importDefault(require("@material-ui/icons/LocalCafeOutlined"));
var LocalCarWashOutlined_1 = __importDefault(require("@material-ui/icons/LocalCarWashOutlined"));
var LocalGasStationOutlined_1 = __importDefault(require("@material-ui/icons/LocalGasStationOutlined"));
var LocalOfferOutlined_1 = __importDefault(require("@material-ui/icons/LocalOfferOutlined"));
var LocalParking_1 = __importDefault(require("@material-ui/icons/LocalParking"));
var LocalPlayOutlined_1 = __importDefault(require("@material-ui/icons/LocalPlayOutlined"));
var LocationOnOutlined_1 = __importDefault(require("@material-ui/icons/LocationOnOutlined"));
var LocalBarOutlined_1 = __importDefault(require("@material-ui/icons/LocalBarOutlined"));
var LocalShippingOutlined_1 = __importDefault(require("@material-ui/icons/LocalShippingOutlined"));
var MonetizationOnOutlined_1 = __importDefault(require("@material-ui/icons/MonetizationOnOutlined"));
var Payment_1 = __importDefault(require("@material-ui/icons/Payment"));
var Place_1 = __importDefault(require("@material-ui/icons/Place"));
var PhoneOutlined_1 = __importDefault(require("@material-ui/icons/PhoneOutlined"));
var RadioButtonUnchecked_1 = __importDefault(require("@material-ui/icons/RadioButtonUnchecked"));
var RestaurantOutlined_1 = __importDefault(require("@material-ui/icons/RestaurantOutlined"));
var Remove_1 = __importDefault(require("@material-ui/icons/Remove"));
var SwapCallsOutlined_1 = __importDefault(require("@material-ui/icons/SwapCallsOutlined"));
var SubdirectoryArrowRight_1 = __importDefault(require("@material-ui/icons/SubdirectoryArrowRight"));
var StarOutlined_1 = __importDefault(require("@material-ui/icons/StarOutlined"));
var Print_1 = __importDefault(require("@material-ui/icons/Print"));
var StoreOutlined_1 = __importDefault(require("@material-ui/icons/StoreOutlined"));
var StoreMallDirectoryOutlined_1 = __importDefault(require("@material-ui/icons/StoreMallDirectoryOutlined"));
var Add_1 = __importDefault(require("@material-ui/icons/Add"));
var PlaceOutlined_1 = __importDefault(require("@material-ui/icons/PlaceOutlined"));
var DragIndicator_1 = __importDefault(require("@material-ui/icons/DragIndicator"));
var Tune_1 = __importDefault(require("@material-ui/icons/Tune"));
var Search_1 = __importDefault(require("@material-ui/icons/Search"));
var Info_1 = __importDefault(require("@material-ui/icons/Info"));
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
var HotelOutlined_1 = __importDefault(require("@material-ui/icons/HotelOutlined"));
var Wifi_1 = __importDefault(require("@material-ui/icons/Wifi"));
var WcOutlined_1 = __importDefault(require("@material-ui/icons/WcOutlined"));
var Schedule_1 = __importDefault(require("@material-ui/icons/Schedule"));
var InsertDriveFileOutlined_1 = __importDefault(require("@material-ui/icons/InsertDriveFileOutlined"));
var FileCopyOutlined_1 = __importDefault(require("@material-ui/icons/FileCopyOutlined"));
var SettingsOutlined_1 = __importDefault(require("@material-ui/icons/SettingsOutlined"));
var PublishOutlined_1 = __importDefault(require("@material-ui/icons/PublishOutlined"));
var GetAppOutlined_1 = __importDefault(require("@material-ui/icons/GetAppOutlined"));
var Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
var EditOutlined_1 = __importDefault(require("@material-ui/icons/EditOutlined"));
var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
var DeleteOutline_1 = __importDefault(require("@material-ui/icons/DeleteOutline"));
var Done_1 = __importDefault(require("@material-ui/icons/Done"));
var DoneAll_1 = __importDefault(require("@material-ui/icons/DoneAll"));
var MapOutlined_1 = __importDefault(require("@material-ui/icons/MapOutlined"));
var PublicOutlined_1 = __importDefault(require("@material-ui/icons/PublicOutlined"));
var LockOutlined_1 = __importDefault(require("@material-ui/icons/LockOutlined"));
var FeedbackOutlined_1 = __importDefault(require("@material-ui/icons/FeedbackOutlined"));
var Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
var WarningOutlined_1 = __importDefault(require("@material-ui/icons/WarningOutlined"));
var MoreVert_1 = __importDefault(require("@material-ui/icons/MoreVert"));
var DeleteOutlined_1 = __importDefault(require("@material-ui/icons/DeleteOutlined"));
var Publish_1 = __importDefault(require("@material-ui/icons/Publish"));
var Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
var VisibilityOutlined_1 = __importDefault(require("@material-ui/icons/VisibilityOutlined"));
var DescriptionOutlined_1 = __importDefault(require("@material-ui/icons/DescriptionOutlined"));
var Bookmark_1 = __importDefault(require("@material-ui/icons/Bookmark"));
var BookmarkBorder_1 = __importDefault(require("@material-ui/icons/BookmarkBorder"));
var BookmarkOutlined_1 = __importDefault(require("@material-ui/icons/BookmarkOutlined"));
var Share_1 = __importDefault(require("@material-ui/icons/Share"));
var ShareOutlined_1 = __importDefault(require("@material-ui/icons/ShareOutlined"));
var TodayOutlined_1 = __importDefault(require("@material-ui/icons/TodayOutlined"));
var InsertInvitationOutlined_1 = __importDefault(require("@material-ui/icons/InsertInvitationOutlined"));
var Person_1 = __importDefault(require("@material-ui/icons/Person"));
var PersonOutline_1 = __importDefault(require("@material-ui/icons/PersonOutline"));
var VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
var VisibilityOffOutlined_1 = __importDefault(require("@material-ui/icons/VisibilityOffOutlined"));
var FilterList_1 = __importDefault(require("@material-ui/icons/FilterList"));
var Sort_1 = __importDefault(require("@material-ui/icons/Sort"));
var Icons_1 = require("./Icons");
var ICON_MAP = {
    accountCircleOutlined: AccountCircleOutlined_1.default,
    accountCircle: AccountCircle_1.default,
    accountBalanceWallet: AccountBalanceWallet_1.default,
    add: Add_1.default,
    arrowBack: ArrowBack_1.default,
    arrowDropUp: ArrowDropUp_1.default,
    arrowDropDown: ArrowDropDown_1.default,
    arrowDropUpOutlined: ArrowDropUpOutlined_1.default,
    arrowDropDownOutlined: ArrowDropDownOutlined_1.default,
    alternateEmailOutlined: AlternateEmailOutlined_1.default,
    assignment: Assignment_1.default,
    assignmentOutlined: AssignmentOutlined_1.default,
    attachFile: AttachFile_1.default,
    bathtubOutlined: BathtubOutlined_1.default,
    buildOutlined: BuildOutlined_1.default,
    exitToApp: ExitToApp_1.default,
    exploreOutlined: ExploreOutlined_1.default,
    expandMore: ExpandMore_1.default,
    expandLess: ExpandLess_1.default,
    localPlay: LocalPlay_1.default,
    creditCard: CreditCard_1.default,
    close: Close_1.default,
    directions: Directions_1.default,
    directionsBoatOutlined: DirectionsBoatOutlined_1.default,
    directionsOutlined: DirectionsOutlined_1.default,
    directionsRailwayOutlined: DirectionsRailwayOutlined_1.default,
    dragIndicator: DragIndicator_1.default,
    getApp: GetApp_1.default,
    arrowRight: ArrowRight_1.default,
    arrowLeft: ArrowLeft_1.default,
    language: Language_1.default,
    localCafeOutlined: LocalCafeOutlined_1.default,
    localCarWashOutlined: LocalCarWashOutlined_1.default,
    localBarOutlined: LocalBarOutlined_1.default,
    localGasStationOutlined: LocalGasStationOutlined_1.default,
    localOfferOutlined: LocalOfferOutlined_1.default,
    localParking: LocalParking_1.default,
    localPlayOutlined: LocalPlayOutlined_1.default,
    locationOnOutlined: LocationOnOutlined_1.default,
    localShippingOutlined: LocalShippingOutlined_1.default,
    monetizationOnOutlined: MonetizationOnOutlined_1.default,
    place: Place_1.default,
    placeOutlined: PlaceOutlined_1.default,
    payment: Payment_1.default,
    phoneOutlined: PhoneOutlined_1.default,
    print: Print_1.default,
    restaurantOutlined: RestaurantOutlined_1.default,
    radioButtonUnchecked: RadioButtonUnchecked_1.default,
    swapCallsOutlined: SwapCallsOutlined_1.default,
    search: Search_1.default,
    storeOutlined: StoreOutlined_1.default,
    storeMallDirectoryOutlined: StoreMallDirectoryOutlined_1.default,
    subdirectoryArrowRight: SubdirectoryArrowRight_1.default,
    starOutlined: StarOutlined_1.default,
    tune: Tune_1.default,
    info: Info_1.default,
    infoOutlined: InfoOutlined_1.default,
    remove: Remove_1.default,
    hotelOutlined: HotelOutlined_1.default,
    wifi: Wifi_1.default,
    wcOutlined: WcOutlined_1.default,
    schedule: Schedule_1.default,
    insertDriveFileOutlined: InsertDriveFileOutlined_1.default,
    fileCopyOutlined: FileCopyOutlined_1.default,
    settingsOutlined: SettingsOutlined_1.default,
    publishOutlined: PublishOutlined_1.default,
    getAppOutlined: GetAppOutlined_1.default,
    edit: Edit_1.default,
    editOutlined: EditOutlined_1.default,
    delete: Delete_1.default,
    deleteOutline: DeleteOutline_1.default,
    done: Done_1.default,
    doneAll: DoneAll_1.default,
    mapOutlined: MapOutlined_1.default,
    publicOutlined: PublicOutlined_1.default,
    lockOutlined: LockOutlined_1.default,
    feedbackOutlined: FeedbackOutlined_1.default,
    warning: Warning_1.default,
    warningOutlined: WarningOutlined_1.default,
    moreVert: MoreVert_1.default,
    deleteOutlined: DeleteOutlined_1.default,
    publish: Publish_1.default,
    visibility: Visibility_1.default,
    visibilityOutlined: VisibilityOutlined_1.default,
    descriptionOutlined: DescriptionOutlined_1.default,
    bookmark: Bookmark_1.default,
    bookmarkOutlined: BookmarkOutlined_1.default,
    bookmarkBorder: BookmarkBorder_1.default,
    share: Share_1.default,
    shareOutlined: ShareOutlined_1.default,
    todayOutlined: TodayOutlined_1.default,
    insertInvitationOutlined: InsertInvitationOutlined_1.default,
    person: Person_1.default,
    personOutline: PersonOutline_1.default,
    visibilityOffOutlined: VisibilityOffOutlined_1.default,
    visibilityOff: VisibilityOff_1.default,
    filterList: FilterList_1.default,
    sort: Sort_1.default,
    filterAltOutlined: Icons_1.FilterAltOutlined
};
exports.default = ICON_MAP;
